import { HttpClient } from '@angular/common/http';
import {Component, OnDestroy, OnInit, Inject} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';

import {PermissionService} from '../../services/permission.service';
import {Observable, Subject, map, of, startWith, throwError} from 'rxjs';
import { Permission } from '../../models/permission';
import { AlertDialog, AlertDialogConfig } from '../alert/dialog';
import { Ec2Service } from '../../services/ec2.service';

@Component({
  standalone: false,
  selector: 'app-add-permission',
  templateUrl: './add-permission-template.html',
  styleUrls: ['./add-permission-style.scss'],
})
export class AddPermissionComponent implements OnInit, OnDestroy {
  showMoreOptions_ = false;
  loading: Boolean= true;
  isExternal = false;
  permissionForm!:  FormGroup;
  readonly nameMaxLength = 24;
  private created_ = false;
  private unsubscribe_ = new Subject<void>();
  resourcesListDictionary : Array<any> = [];
  filteredResourcesByName!: Observable<any[]> | undefined ;
  policiesListDictionary : Array<string> = ['LIST', 'READ', 'STOP', 'START', 'FULL'];
  filteredPoliciesByName!: Observable<string[]> | undefined ;
  submitting = false;

  constructor(
    public dialogRef: MatDialogRef<AddPermissionComponent>,
    private permissionService: PermissionService,
    private ec2Service: Ec2Service,
    private readonly route_: ActivatedRoute,
    private readonly fb_: FormBuilder,
    private readonly dialog_: MatDialog,
    private readonly router_: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  get name(): AbstractControl | null {
    return this.permissionForm.get('name');
  }
  
  get resources() : FormGroup {
    return this.permissionForm.get("resources") as FormGroup
  }

  get resource() : FormGroup {
    return this.permissionForm.get("resource") as FormGroup
  }

  get usePattern() : AbstractControl | null {
    return this.permissionForm.get('usePattern');
  }

  get policies() : FormGroup {
    return this.permissionForm.get("policies") as FormGroup
  }

  dump(o:any){
    console.log(' ==> o = ', o)
  }
  
  ngOnInit(): void {
    this.ec2Service.get()
          .subscribe(result => {
            this.resourcesListDictionary = result;
            this.loading = false
          }
          ); 
    this.permissionForm = this.fb_.group({
      usePattern: [false, []],
      name: ['', [ Validators.required]],
      resource: ['', []],
      resources: ['', []],
      policies: ['', []],
    });      
    this.filteredResourcesByName = this.permissionForm.get('resources')?.valueChanges
            .pipe(
              startWith(''),
              map(value => this._filter(value || ''))
            )|| of(this.resourcesListDictionary.map(item => item.name));
    this.filteredPoliciesByName = this.permissionForm.get('policies')?.valueChanges
            .pipe(
              startWith(''),
              map(value => this._filterPolicies(value || ''))
            )|| of(this.resourcesListDictionary);
  }

  ngOnDestroy(): void {
    this.unsubscribe_.next();
    this.unsubscribe_.complete();
  }


  hasUnsavedChanges(): boolean {
    return this.permissionForm.dirty;
  }

  isCreateDisabled(): boolean {
    return !this.permissionForm.valid;
  }  

  cancel(): void {
    this.dialogRef.close();
  }

  add(): void {
    const permission =  {
      name: (this.name)? this.name.value : null, 
      resource: this.resource ? this.resource.value : null,
      resources: this.resources ? this.resources.value : null,
      usePattern: this.usePattern ? this.usePattern.value : null,
    }
    
    this.permissionService.addPermission(permission)
    .subscribe( _ => {
      if(!_.status){
        const config = {
          title: 'Erreur',
          message: 'Une erreur est survenue lors de l\'ajout de ce rôle : ' + _.message,
          confirmLabel: 'OK'
        } as AlertDialogConfig;
        this.dialog_.open(AlertDialog, {data: config});
      }else{
        this.dialogRef.close();
      }
    },
    error => {
      const config = {
        title: 'Erreur',
        message: 'Une erreur est survenue lors de l\'ajout de cet utilisateur : ' + error,
        confirmLabel: 'OK'
      } as AlertDialogConfig;
      this.dialog_.open(AlertDialog, {data: config});
      return throwError(error);
    }
    );
  }


  canDeactivate(): boolean {
    return this.permissionForm.pristine || this.created_;
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.resourcesListDictionary.filter(option => option && option.name && option.name.toLowerCase().includes(filterValue));
  }

  private _filterPolicies(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.policiesListDictionary.filter(option => option  && option.toLowerCase().includes(filterValue));
  }
}
